"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredContentForOrganization = exports.ORGANIZATION_CONTENT_FILTERS = void 0;
const store_1 = __importDefault(require("@app/store"));
const _1 = require(".");
const ORGANIZATION_CONTENT_FILTERS = (extraParams) => Object.freeze({
    // Sportisimo
    AofOCI1v4: {
        timeoff_conflict_dropdown_option3: null, // FORMAT: this means that content with "timeoff_conflict_dropdown_option3" type will be replaced by "null" for this organization
        timeoff_conflict_dropdown_option4: null,
        timeoff_conflict_dropdown_option5: null,
        agreement_name: (0, _1.t)('SPORTISIMO_AGREEMENT'),
        agreement_name_current: (0, _1.t)('SPORTISIMO_CURRENT_CONTRACTS'),
        agreement_name_future: (0, _1.t)('SPORTISIMO_FUTURE_CONTRACTS'),
        agreement_name_past: (0, _1.t)('SPORTISIMO_PAST_CONTRACTS'),
        time_off_edit_include_hour_option_contract: null,
        time_off_edit_include_hour_option_settings: null,
        employee_card_hide_emp: null,
        overtime_unpaid_false_should_be_ordered: true,
    },
    // Sportisimo Logistika (sklad)
    sqnFS_l8QF: {
        timeoff_conflict_dropdown_option3: null, // FORMAT: this means that content with "timeoff_conflict_dropdown_option3" type will be replaced by "null" for this organization
        timeoff_conflict_dropdown_option4: null,
        timeoff_conflict_dropdown_option5: null,
        agreement_name: (0, _1.t)('SPORTISIMO_AGREEMENT'),
        agreement_name_current: (0, _1.t)('SPORTISIMO_CURRENT_CONTRACTS'),
        agreement_name_future: (0, _1.t)('SPORTISIMO_FUTURE_CONTRACTS'),
        agreement_name_past: (0, _1.t)('SPORTISIMO_PAST_CONTRACTS'),
        time_off_edit_include_hour_option_contract: null,
        time_off_edit_include_hour_option_settings: null,
        employee_card_hide_emp: null,
        overtime_unpaid_false_should_be_ordered: true,
        terminal_settings_read_only: true,
        enable_external_contract_type: true,
        edit_employee_vacation_fund: true,
        vacation_editable_only_for_external: true,
    },
    // Tchibo (CZ)
    YC_stvpc9B: {
        shift_overtime_unpaid_toil: null,
        agreement_name: (0, _1.t)('SPORTISIMO_AGREEMENT'),
        agreement_name_current: (0, _1.t)('SPORTISIMO_CURRENT_CONTRACTS'),
        agreement_name_future: (0, _1.t)('SPORTISIMO_FUTURE_CONTRACTS'),
        agreement_name_past: (0, _1.t)('SPORTISIMO_PAST_CONTRACTS'),
    },
    // Tchibo Slovensko (SK)
    VXWHAT_GqL: {
        shift_overtime_unpaid_toil: null,
        agreement_name: (0, _1.t)('SPORTISIMO_AGREEMENT'),
        agreement_name_current: (0, _1.t)('SPORTISIMO_CURRENT_CONTRACTS'),
        agreement_name_future: (0, _1.t)('SPORTISIMO_FUTURE_CONTRACTS'),
        agreement_name_past: (0, _1.t)('SPORTISIMO_PAST_CONTRACTS'),
    },
    // Zrno Zrnko
    VebPEUjg1xhG: {
        agreement_name: (0, _1.t)('SPORTISIMO_AGREEMENT'),
        agreement_name_current: (0, _1.t)('SPORTISIMO_CURRENT_CONTRACTS'),
        agreement_name_future: (0, _1.t)('SPORTISIMO_FUTURE_CONTRACTS'),
        agreement_name_past: (0, _1.t)('SPORTISIMO_PAST_CONTRACTS'),
        edit_employee_vacation_fund: true,
    },
    // Moravia Cans
    acFVAdebWUU6: {
        timeoff_conflict_dropdown_option1: null,
        timeoff_conflict_dropdown_option3: null,
        timeoff_conflict_dropdown_option4: null,
        // only timeoff_conflict_dropdown_option5 should be visible
    },
    // Teleperformance
    '7RnVL2ZDE7': {
        // only timeoff_conflict_dropdown_option1 should be visible
        timeoff_conflict_dropdown_option3: null,
        timeoff_conflict_dropdown_option4: null,
        timeoff_conflict_dropdown_option5: null,
        custom_attribute_on_agenda: extraParams?.customContent,
        agenda_instance_name: null,
        error_on_agenda_without_attribute: {
            hasError: true,
            errorMessage: (0, _1.t)('ERR_MESSAGE.shift.agendaWithoutAttribute'),
        },
        disable_email_editation_on_invite: true,
    },
    // Lindt
    UE_TbIIsl4: {
        employee_card_hide_emp: null,
        org_bonuses_nts_column_label: (0, _1.t)('NTS_BONUS'),
        org_bonuses_nts_man_column_label: (0, _1.t)('NTS_BONUS_MAN'),
        org_bonuses_kpi_ms_column_label: (0, _1.t)('KPI_MS_BONUS'),
        org_bonuses_kpi_ms_man_column_label: (0, _1.t)('KPI_MS_BONUS_MAN'),
        org_bonuses_other_column_label: (0, _1.t)('OTHER_BONUS'),
        org_bonuses_other_man_column_label: (0, _1.t)('OTHER_BONUS_MAN'),
    },
});
exports.ORGANIZATION_CONTENT_FILTERS = ORGANIZATION_CONTENT_FILTERS;
const getFilteredContentForOrganization = (contentType, normalContent, extraParams, organizationIdOverride) => {
    const organizationId = organizationIdOverride ?? store_1.default.getState()?.organizationId;
    const _content = (0, exports.ORGANIZATION_CONTENT_FILTERS)(extraParams);
    if (organizationId &&
        Object.keys(_content).includes(organizationId) &&
        Object.keys(_content[organizationId]).includes(contentType)) {
        return _content[organizationId][contentType];
    }
    else {
        return normalContent;
    }
};
exports.getFilteredContentForOrganization = getFilteredContentForOrganization;
